import React from 'react';
import classes from './Background.module.scss';

const Background = (props) => {
  return <div className={classes.background}>{props.children}</div>;
};

export default Background;
